import {getCioCategories} from 'hec/helpers/constructorHelpers'
import {useAppOrigin} from '~/app/hooks/use-app-origin'
import {useQuery} from '@tanstack/react-query'

export const useFetchCioProductCategory = (
    categoryId: string,
    resultCount: number,
    shouldQuery: boolean
) => {
    const appOrigin = useAppOrigin()
    return useQuery({
        queryKey: ['constructor-product-category', categoryId, resultCount],
        queryFn: async () => {
            return await getCioCategories(appOrigin, categoryId, {
                resultsPerPage: resultCount,
                filterMatchTypes: {}
            })
        },
        enabled: shouldQuery
    })
}
